/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum TemplateReviewDecision {
  APPROVED="APPROVED",
REJECTED="REJECTED"
}

/**
* TemplateReviewDecision
*/
export const TemplateReviewDecisionEnumType = types.enumeration("TemplateReviewDecision", [
        "APPROVED",
  "REJECTED",
      ])
